export default "__VITE_ASSET__DQmSKt43__"